import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { signOut } from '#pplx/frontend/apps/ask/auth/signOut.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const AccountMenuSignOutItem = () => {
    useIntl();
    const handleSignOut = useCallback(() => {
        signOut({ redirect: true, callbackUrl: '/' });
    }, []);
    return (_jsx(DropdownMenu.Item, { onSelect: handleSignOut, leadingAccessory: $icon('logout'), children: _jsx(FormattedMessage, { defaultMessage: "Sign out", description: "Menu item in the sidebar account popover to sign out of the current session", id: "142273e616" }) }));
};
//# sourceMappingURL=AccountMenuSignOutItem.js.map